import React from 'react';
import { v4 as uuidv4 } from 'uuid';

const Conditions = ({ offerPolicy }) => {
  return (
    <div className="popin-condition__content">
      <div className="offerPolicy-tab popin-tabs">
        {offerPolicy.content.policies.map((item) => {
          return (
            <React.Fragment key={uuidv4()}>
              <h5>{item.label}</h5>
              <p>{item.description}</p>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Conditions;
